import React, { FC, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { trackPage } from '../lib/analytics';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { ROUTES } from '../config/routes';
import NavBar from './NavBar';
import Register from '../screens/Register';
import Waiting from '../screens/Waiting';
import TermsAndConditions from '../screens/TermsAndConditions';

// ✅ INTERFACE PARA ROUTE CONFIG
interface RouteConfig {
  path: string;
  element: React.ReactElement;
  requiresAuth: boolean;
  redirectTo?: string;
}

const RouteTracker: FC = () => {
  const location = useLocation();
  useEffect(() => {
    trackPage(location.pathname);
  }, [location.pathname]);
  return null;
};

// ✅ COMPONENTE PRINCIPAL CON NAMING CONSISTENTE
const AppRoutes: FC = () => {
  const { token, business_id } = useSelector((state: RootState) => state.user);

  // ✅ CONFIGURACIÓN DE RUTAS CENTRALIZADA
  const routeConfigs: RouteConfig[] = [
    {
      path: ROUTES.HOME,
      element: <Register />,
      requiresAuth: false,
      redirectTo: ROUTES.WAITING,
    },
    {
      path: ROUTES.REGISTER,
      element: <Register />,
      requiresAuth: false,
      redirectTo: ROUTES.WAITING,
    },
    {
      path: ROUTES.WAITING,
      element: <Waiting />,
      requiresAuth: false,
    },
    {
      path: ROUTES.TERMS_AND_CONDITIONS,
      element: <TermsAndConditions />,
      requiresAuth: false,
    },
  ];

  // ✅ FUNCIÓN PARA RENDERIZAR RUTAS CON LÓGICA DE REDIRECCIÓN
  const renderRoute = (config: RouteConfig) => {
    if (config.requiresAuth && token && config.redirectTo) {
      return <Navigate to={config.redirectTo} replace />;
    }
    if (!config.requiresAuth && token && config.redirectTo) {
      return <Navigate to={config.redirectTo} replace />;
    }
    return config.element;
  };

  // ✅ CONDICIÓN PARA MOSTRAR NAVBAR
  const shouldShowNavBar = token && business_id;

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <RouteTracker />
      <Routes>
        {routeConfigs.map(config => (
          <Route
            key={config.path}
            path={config.path}
            element={renderRoute(config)}
          />
        ))}
      </Routes>
      {/* ✅ NAVBAR CONDICIONAL */}
      {shouldShowNavBar && <NavBar />}
    </Router>
  );
};

export default AppRoutes;
